// extracted by mini-css-extract-plugin
module.exports = {"PersonalityResults":"UserPersonalityResult_PersonalityResults__3m7jU","ResultTitle":"UserPersonalityResult_ResultTitle__1hf4E"};